import window from "@shared/utils/app-window.ts";
import Keycloak from "keycloak-js";
import { KeycloakMock } from "@shared/stores/keycloak.ts";

type KeycloakState = {
  _keycloak: Keycloak;
  _isInitialized: boolean;
};
type MockedKeycloakState = {
  _keycloak: KeycloakMock;
  _isInitialized: boolean;
};

export const keyCloakOrMock = (
  realState: KeycloakState,
): KeycloakState | MockedKeycloakState => {
  if (import.meta.env.MODE === "test") {
    return {
      _keycloak: {
        init: async () => {},
        login: async () => {},
        createLoginUrl: async (options) => {
          const params = new URLSearchParams({
            client_id: window.KEYCLOAK_CLIENT_ID,
            redirect_uri: options?.redirectUri || window.location.href,
            response_mode: "fragment",
            response_type: "code",
            scope: `openid ${options?.scope || ""}`.trim(),
            code_challenge: "mock-code-challenge",
            code_challenge_method: "S256",
          });
          if (options?.loginHint) {
            params.append("login_hint", options.loginHint);
          }
          return `${window.KEYCLOAK_URL}/realms/${window.KEYCLOAK_REALM}/protocol/openid-connect/auth?${params.toString()}`;
        },
        logout: async () => {},
        updateToken: async () => {},
        authenticated: !["/", "/login"].includes(window.location.pathname),
        token: "test-token",
      },
      _isInitialized: true,
    };
  }

  return realState;
};
